import { Component, inject } from '@angular/core';
import { finalize, Observable, of } from 'rxjs';
import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../shared/services/common.service';
import { AutofillmsmeService } from '../../../../shared/services/autofillmsme.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, Validators } from '@angular/forms';
import { map, catchError } from 'rxjs/operators'; // ⬅️ Add this line

@Component({
  selector: 'app-eoiverificationofmsme',
  templateUrl: './eoiverificationofmsme.component.html',
  styleUrl: './eoiverificationofmsme.component.css'
})
export class EoiverificationofmsmeComponent {

  eoiData: any;
  isFieldsDisabled: boolean = false;

  private _formBuilder = inject(FormBuilder);
  data: any[];
  isDirty = false; // Set to true when user changes something
  loadingSequence: boolean = false;

  firstFormGroup = this._formBuilder.group({
    udyamRegistrationNumber: ['',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.udyamNumber)
      ]),
    ],
    ownersMobileNumber: [
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.mobilePattern)
      ])
    ],
    //otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
  });

  otpFormGroup = this._formBuilder.group({
    //udyamRegistrationNumber: [{ value: '', disabled: true }],
    //ownersMobileNumber: [{ value: '', disabled: true }],
    otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
  });

  ngOnInit() {
    this.isOTPSent = false;//inserted for displaying new fields on otp success
    sessionStorage.clear();
    this.firstFormGroup
      .get('udyamRegistrationNumber')
      ?.valueChanges.subscribe((value: string | null) => {
        if (value && value.startsWith('UDYAM-MH-')) {
          const prefix = 'UDYAM-MH-';
          // Remove any non-numeric characters after the prefix
          let formattedValue = value.slice(prefix.length).replace(/[^0-9]/g, '');
          // Add a hyphen after the first two digits if needed
          if (formattedValue.length > 2) {
            formattedValue = `${formattedValue.slice(0, 2)}-${formattedValue.slice(2)}`;
          }
          // Update the field value with the formatted value
          this.firstFormGroup
            .get('udyamRegistrationNumber')
            ?.setValue(prefix + formattedValue, { emitEvent: false });
        } else if (value === null || value === '') {
          // Reset the value to the default prefix if empty or null
          this.firstFormGroup
            .get('udyamRegistrationNumber')
            ?.setValue('', { emitEvent: false });
        }
      });
  }

  isOTPSent: boolean = false;
  udyamNumber: string = '';
  mobileNumber: string = '';
  

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private msme_serv: AutofillmsmeService,
    private ngxUiLoaderService: NgxUiLoaderService,) {
    this.data = [];

    this.firstFormGroup.valueChanges.subscribe(() => {
      this.isDirty = true;
    });
  }

  get f() {
    return this.firstFormGroup.controls;
  }

  //This method is used with Udyam API Integration
  //verifyUser() {
  //  if (this.firstFormGroup.invalid) {
  //    this.toastrService.error("Invalid form. Please fill out all required fields correctly.");
  //    return;
  //  }

  //  const u_num = this.firstFormGroup.controls.udyamRegistrationNumber.value;
  //  const mob = this.firstFormGroup.controls.ownersMobileNumber.value;

  //  if (u_num && mob) {
  //    const formDatavalue = {
  //      udyamRegistrationNumber: this.firstFormGroup.controls.udyamRegistrationNumber.value,
  //      ownersMobileNumber: this.firstFormGroup.controls.ownersMobileNumber.value
  //    }

  //    const dtoUdyam = {
  //      authToken: "",
  //      clientId: "",
  //      udyamNo: this.firstFormGroup.controls.udyamRegistrationNumber.value,
  //      mobile: this.firstFormGroup.controls.ownersMobileNumber.value
  //    }

  //    this.loadingSequence = true;
  //    //-----------------------------------------------------------------------------
  //    /*Check this msme is exists into usermsme table - if yes then check isEOISubmitted? if yes then disallow to submit EOI*/
  //    /*Now now check into EOI.Enterprisedetails table - if yes then disallow to submit EOI */
  //    /*If not exists in both of the above table- then fetch details from Udyam Api */
  //    //-----------------------------------------------------------------------------
  //    this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue, true).subscribe(
  //      res => {
  //        if (res.status) {
  //          sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
  //          sessionStorage.setItem("ownersMobileNumber", mob || '');
  //          this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).subscribe(
  //            response => {
  //              if (response.isResponse === 'Y') {
  //                sessionStorage.setItem("isUdyamVerified", 'true');
  //                sessionStorage.setItem("email", response.data.email.trim());
  //                sessionStorage.setItem('msmeuserVerificationCompleted', 'true');
  //                //this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //              } else if ((response.isResponse === 'E1') || (response.isResponse === 'E3')) {
  //                this.toastrService.error(response.msg);
  //                this.loadingSequence = false;
  //                //let userResponse: boolean = confirm(response.msg + " : No matching record found from Udyam Portal. Register as a new User?");
  //                //if (userResponse) {
  //                //  sessionStorage.setItem("isUdyamVerified", 'false');
  //                //  this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //                //}
  //              } else if (response.isResponse === 'E2') { //When E2= Technical Error
  //                this.toastrService.error(response.msg);
  //                this.loadingSequence = false;
  //                //let userResponse: boolean = confirm("A technical issue occurred while fetching the record from the Udyam Portal. Would you like to register as a new user?");
  //                //if (userResponse) {
  //                //  sessionStorage.setItem("isUdyamVerified", 'false');
  //                //  this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //                //}
  //                // above code is commented as per suggested by Swapnali Mam and Mr. Harshal-BA- on 24th Feb 2025, as Dept want to block manual entry for
  //                // registration process....
  //              }
  //            }
  //          );
  //          finalize(() => {
  //            this.loadingSequence = false;  // Stop the loader after both calls complete (success or error)
  //          })
  //        }
  //      }
  //    );
  //  } else {
  //    this.toastrService.error("Please provide both Udyam Registration Number and Mobile Number.");
  //  }
  //}


  //This method is used for AutoFill.Json file
  //verifyUser() {
  //  if (this.firstFormGroup.invalid) {
  //    this.toastrService.error("Invalid form. Please fill out all required fields correctly.");
  //    return;
  //  }

  //  const u_num = this.firstFormGroup.controls.udyamRegistrationNumber.value;
  //  const mob = this.firstFormGroup.controls.ownersMobileNumber.value;

  //  if (u_num && mob) {
  //    const formDatavalue = {
  //      udyamRegistrationNumber: this.firstFormGroup.controls.udyamRegistrationNumber.value,
  //      ownersMobileNumber: this.firstFormGroup.controls.ownersMobileNumber.value
  //    }
  //    this.msme_serv.verifyUdyamAndMobile(u_num, mob).then(result => {
  //      if (result) {
  //        this.toastrService.success("Record verified from Udyam Portal successfully!");
  //        this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue).subscribe(
  //          res => {
  //            if (res.status) {
  //              sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
  //              sessionStorage.setItem("ownersMobileNumber", mob || '');
  //              sessionStorage.setItem("isUdyamVerified", 'true');
  //              this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //            }
  //          }
  //        );
  //      } else {
  //        this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue).subscribe(
  //          res => {
  //            if (res.status) {
  //              sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
  //              sessionStorage.setItem("ownersMobileNumber", mob || '');
  //              alert("No matching record found from Udyam Portal. Register as new User");
  //              sessionStorage.setItem("isUdyamVerified", 'false');
  //              this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //            }
  //          }
  //        );
  //      }
  //    })
  //  } else {
  //    this.toastrService.error("Please provide both Udyam Registration Number and Mobile Number.");
  //  }
  //}   

  goToLogin() {
    this.router.navigate(['']);
  }

  //sayali
  vverify() {
    const udyamNo = this.firstFormGroup.get('udyamRegistrationNumber')?.value || '';
    const mobileNo = this.firstFormGroup.get('ownersMobileNumber')?.value || '';

    sessionStorage.setItem("Udyamno", udyamNo);
    sessionStorage.setItem("MobileNo", mobileNo);

    sessionStorage.setItem("EOIOTPVerification", 'true');
    this.router.navigate(['/eoiotpverification']);
  }

  verify(): void {
    debugger;
    if (this.firstFormGroup.invalid) {
      this.toastrService.error("Invalid form. Please fill out all required fields.");
      return;
    }

    const formValue = this.firstFormGroup.getRawValue();
    const udyamNo = formValue.udyamRegistrationNumber?.trim();
    const mobileNo = formValue.ownersMobileNumber?.trim();

    if (!udyamNo || !mobileNo) {
      this.toastrService.error("Udyam Registration Number and Mobile Number are required.");
      return;
    }

    this.loadingSequence = true; // ⬅️ Start loader before anything begins

    const formData = {
      udyamRegistrationNumber: udyamNo,
      ownersMobileNumber: mobileNo
    };

    const dtoUdyam = {
      authToken: "",
      clientId: "",
      udyamNo: udyamNo,
      mobile: mobileNo
    };

    this.apiService.postRequest(API_ENDPOINTS.MSME.EOIVALIDATEUSER, formData, true).subscribe({
      next: (res: any) => {
        if (res.status) {
          sessionStorage.setItem("udyamRegistrationNumber", udyamNo);
          sessionStorage.setItem("ownersMobileNumber", mobileNo);

          this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).pipe(
            finalize(() => this.loadingSequence = false) // ⬅️ Stop loader after last API
          ).subscribe({
            next: (response: any) => {
              if (response.isResponse === 'Y') {
                sessionStorage.setItem("isUdyamVerified", 'true');
                sessionStorage.setItem("email", response.data.email?.trim() || '');
                sessionStorage.setItem("EOIOtpVerified", 'true');


                //fetching data and need to send it tot he form
                const activities = response.data.activities;
                let nicCodes = '';

                if (activities && activities.length > 0) {
                  // Map the array of objects to an array of just the NIC codes
                  const codeArray = activities.map((activity: any) => activity.niC5DigitId);

                  // Join the array elements into a single comma-separated string
                  nicCodes = codeArray.join(', ');
                }




                this.eoiData = {
                  UdyamRegistrationNumber: response.data.udyamRegistrationNumber,
                  EnterpriseName: response.data.nameOfEnterprise,
                  AuthorizedPersonName: response.data.name,
                  DateOfEstablishment: response.data.dateOfIncorporation,
                  PresentAddress: response.data.officialAddressOfEnterprise,
                  //NICCode: response.data.activities[0].niC5DigitId,
                  NICCode: nicCodes,
                  Sector: response.data.majorActivity,
                  Pin: response.data.pin,
                  Gender: response.data.gender,
                  SocialCategory: response.data.socialCategory,
                  EnterpriseType: response.data.enterpriseType,
                  District: response.data.district,

                };

                

                // New Logic: After successful user verification, send the OTP.
                this.toastrService.success(response.message || "User verified. Sending OTP...");
                this.SendOTP();
                //this.router.navigate(['/eoi'], { state: { eoiData: this.eoiData } });

              } else {
                this.toastrService.error(response.msg);
              }
            },
            error: () => {
              this.toastrService.error("Error verifying with Udyam portal.");
            }
          });

        } else {
          this.loadingSequence = false; // ⬅️ Stop loader if validate API failed
          this.toastrService.warning(res.message || "Not allowed to submit EOI.");
        }
      },
      error: () => {
        this.loadingSequence = false;
        this.toastrService.error("Error validating MSME.");
      }
    });
  }

  SendOTP(): void {
    if (!this.f.ownersMobileNumber) {
      this.toastrService.error('Mobile number is missing. Cannot send OTP.');
      return;
    }

    this.f
    const otpData = {
      otpType: 'mobile',
      otpValue: this.f.ownersMobileNumber.value
    //  otpValue: '9755644221' //  Mobile no for EOI Demo.
     // otpValue: '9773394664' // Tushar's Mobile no for EOI Demo.      
      //otpValue: '9890729158' // Harshal's Mobile no for EOI Demo.

    };

    this.apiService.postRequest(API_ENDPOINTS.EOI.EOISendOTP, otpData).subscribe({
      next: (response: any) => {
        if (response.status) {
          
          this.toastrService.success(response.message || 'OTP sent successfully.');
          this.isOTPSent = true; // ✅ Set flag
          this.isFieldsDisabled = true; //to disbale udyam and no and verify button

          this.firstFormGroup.get('udyamRegistrationNumber')?.disable();
          this.firstFormGroup.get('ownersMobileNumber')?.disable();

          // ⬅️ Disable the entire form group here
          //this.firstFormGroup.disable();


          const udyamNo = this.firstFormGroup.get('udyamRegistrationNumber')?.value || '';
          const mobileNo = this.firstFormGroup.get('ownersMobileNumber')?.value || '';
          sessionStorage.setItem("Udyamno", udyamNo);
          sessionStorage.setItem("MobileNo", mobileNo);
          sessionStorage.setItem("EOIOTPVerification", 'true');
          //this.router.navigate(['/eoiotpverification']);
        } else {
          
          this.toastrService.error(response.message || 'Failed to send OTP. Try again.');
          this.isOTPSent = false;
          this.isFieldsDisabled = false; // Re-enable on failure
        }
      },
      error: () => {
        
        this.toastrService.error('Error occurred while sending OTP.');
        this.isOTPSent = false;
        this.isFieldsDisabled = false; // Re-enable on error
      }
    });
  }

  get f2() {
    return this.otpFormGroup.controls;
  }

  
  //ag
  //verifyMobileOtp(): Observable<boolean> {
  //  const otp = this.otpFormGroup.controls['otp'].value?.toString();

  //  if (!otp || otp.length !== 6) {
  //    this.toastrService.error("Please enter a valid 6-digit OTP.");
  //    return of(false); // Return a completed Observable of false
  //  }

  //  const otpdata = {
  //    OtpType: 'mobile',
  //    OtpValue: '7709115379', // Assuming this is correct
  //    Otp: otp
  //  };

  //  return this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).pipe(
  //    map((res: any) => {
  //      if (res.message === "OTP verified successfully.") {
  //        this.toastrService.success(res.message);
  //        return true;
  //      } else {
  //        this.toastrService.error(res.message || "OTP verification failed.");
  //        return false;
  //      }
  //    }),
  //    catchError(() => {
  //      this.toastrService.error("Error verifying OTP.");
  //      return of(false);
  //    })
  //  );
  //}

  verifyOTP(): Observable<boolean> {
    const otp = this.otpFormGroup.controls['otp'].value?.toString();

    if (!otp || otp.length !== 6) {
      this.toastrService.error("Please enter a valid 6-digit OTP.");
      return of(false);
    }

    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.f.ownersMobileNumber.value,
       //OtpValue: '9755644221', //  Mobile no for EOI Demo.
   //  otpValue: '9773394664' ,// Tushar's Mobile no for EOI Demo.
      //otpValue: '8109991164',// Rounak's Mobile no for EOI Demo. 

      Otp: otp
    };

    return new Observable<boolean>((observer) => {
      this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe({
        next: (res) => {
          if (res.message === "OTP verified successfully.") {
            this.toastrService.success(res.message);
            observer.next(true);
          } else {
            this.toastrService.error(res.message || "OTP verification failed.");
            observer.next(false);
          }
          observer.complete();
        },
        error: () => {
          this.toastrService.error("Error verifying OTP.");
          observer.next(false);
          observer.complete();
        }
      });
    });

    //return new Observable<boolean>((observer) => {
    //  this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe({
    //    next: (res) => {
    //      // First, handle the specific business logic error
    //      if (res.message === "EOI already exists for this UDYAM number. Duplicate submission is not allowed.") {
    //        this.toastrService.error(res.message);
    //        observer.next(false);
    //      }
    //      // Then, handle non-successful messages
    //      else if (res.message !== "OTP verified successfully.") {
    //        this.toastrService.error(res.message || "OTP verification failed.");
    //        observer.next(false);
    //      } else {
    //        // Finally, handle the successful verification message
    //        this.toastrService.success(res.message);
    //        observer.next(true);
    //      }
    //      observer.complete();
    //    },
    //    error: () => {
    //          this.toastrService.error("Error verifying OTP.");
    //          observer.next(false);
    //          observer.complete();
    //        }
    //  });
    //});
  }

  

  resendOTP() {
    if (!this.mobileNumber) {
      this.toastrService.error('Mobile number is missing. Cannot resend OTP.');
      return;
    }

    const otpData = {
      otpType: 'mobile',
      otpValue: this.f.ownersMobileNumber.value
    /*  otpValue: '9755644221' //  Mobile no for EOI Demo.*/
      //  otpValue: '9773394664',// Tushar's Mobile no for EOI Demo
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpData).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.toastrService.success(response.message || 'OTP resent successfully.');
          this.isOTPSent = true; // ✅ Set flag
        } else {
          this.toastrService.error(response.message || 'Failed to resend OTP. Try again.');
          this.isOTPSent = false;
        }
      },
      error: () => {
        this.toastrService.error('Error occurred while resending OTP.');
        this.isOTPSent = false;
      }
    });
  }

  // Add this function to your component class
  handleOtpVerification(): void {
    // Show a loading indicator if you have one
    this.loadingSequence = true;

    this.verifyOTP().subscribe({
      next: (isVerified) => {
        // This block runs when the Observable emits a value
        this.loadingSequence = false; // Hide the loader

        if (isVerified) {
          // Verification was successful
          console.log('OTP verification successful!');
          // Add your success logic here, e.g., navigate to a new page
          //this.router.navigate(['/next-page']);
          this.router.navigate(['/eoi'], { state: { eoiData: this.eoiData } });
        } else {
          // Verification failed
          console.log('OTP verification failed.');
          // The toast message is already shown by verifyOTP(), so no extra action needed here
        }
      },
      error: (err) => {
        // This block runs if there's a network error
        this.loadingSequence = false;
        console.error('An error occurred during OTP verification:', err);
      }
    });
  }
}
